<template>

	<div class="message">
		<div v-on:click="open" class="message-icon">
			<i class="material-icons md-18">chat</i>
		</div>
		<messageModal v-if="show" :close="close" message=""/>
	</div>
</template>

<script>

import messageModal from './message-modal';

export default {
	name:'parcelSave',
	props: {},
	components:{
		messageModal,
	},
	computed:{
		show:function(){
			return this.$store.state.message.show;
		},
	},
	created:function(){
	},
	methods:{
		close:function(){
			this.$store.dispatch('MESSAGE_SHOW', {
				show: false
			})
		},
		open:function(){
			this.$store.dispatch('MESSAGE_SHOW', {
				show: true
			})
		},
		submit: function(){

		},
	}
};

</script>
<style scoped>
	.message-icon{position:fixed;bottom:24px;right:10px;cursor:pointer;
		width:38px;height:38px;line-height:36px;text-align:center;color:#FFF;border-radius:24px;
		background-color:#273237;}
	.mobile .message-icon{display:none;}
	.message-icon i{color:#FFF;}
	.message-icon span{font-size:8px;}
	.message-icon:hover{background-color:#192023;}
</style>


// WEBPACK FOOTER //
// src/components/message/message.vue